import { h, markRaw } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const DEFAULT_PREFIX = 'fas';

const normalizeIcon = (icon) => (Array.isArray(icon) ? icon : [DEFAULT_PREFIX, icon]);

/**
 * Creates a markRaw Vue component that renders a Font Awesome icon.
 * Use for Element Plus / aiq icon props such as prefix-icon and suffix-icon.
 *
 * @param {string|Array<string>} icon - Icon name or [prefix, name] tuple
 * @param {Object} [options]
 * @param {string} [options.name] - Component name for devtools
 * @param {Object} [options.props] - Additional props passed to FontAwesomeIcon
 */
export const createFontAwesomeIcon = (icon, { name, props: iconProps = {} } = {}) => {
  const iconDef = normalizeIcon(icon);
  const componentName = name || `FontAwesomeIcon-${iconDef.join('-')}`;

  return markRaw({
    name: componentName,
    render() {
      return h(FontAwesomeIcon, { icon: iconDef, ...iconProps });
    },
  });
};
